/**
 * Insider Integration — Configuration
 * Only public frontend configuration. No secrets.
 */

export const insiderConfig = {
  /** Feature flag — disable to stop sending data without removing code */
  enabled: import.meta.env.VITE_INSIDER_ENABLED === 'true',

  /** Insider partner name (public, used for script URL) */
  partnerName: import.meta.env.VITE_INSIDER_PARTNER_NAME || '',

  /** Custom Identifier system name (confirmed with Insider IRM) */
  customIdentifierKey: import.meta.env.VITE_INSIDER_CUSTOM_ID_KEY || 'cpf',
} as const;
